
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g1ccm", function(module, exports) {
$parcel$export(module.exports, "PricingTabs", function () { return (parcelRequire("9RHgs")).PricingTabs; });
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("baTp3")).DataCenterSection; });
$parcel$export(module.exports, "QuestionsCta", function () { return (parcelRequire("frz5c")).QuestionsCta; });
$parcel$export(module.exports, "DemoAddOn", function () { return (parcelRequire("1jOvc")).DemoAddOn; });
$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return (parcelRequire("djE2J")).AtlassianGuardAddOnShared; });

var $kYeRR = parcelRequire("kYeRR");
parcelRequire("h9b6O");
parcelRequire("9RHgs");
parcelRequire("21Gmw");
parcelRequire("gqa4z");
parcelRequire("8Bcrk");
parcelRequire("jQCkx");
parcelRequire("frz5c");
parcelRequire("1jOvc");
parcelRequire("djE2J");

});
parcelRegister("kYeRR", function(module, exports) {
/* pricing-tiers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $1341a3436472bd20$var$sectionCss = null;
const $1341a3436472bd20$var$headerCss = null;
const $1341a3436472bd20$var$cardsWrapperCss = null;
const $1341a3436472bd20$var$cardWrapperCss = null;
const $1341a3436472bd20$var$costCss = null;
const $1341a3436472bd20$var$costAndQuantityColor = "#172b4d";
const $1341a3436472bd20$var$costLabelCss = null;
const $1341a3436472bd20$var$quantityCss = null;
const $1341a3436472bd20$var$footerWrapperCss = null;
const $1341a3436472bd20$var$PricingCard = ({ ctaEmphasis: ctaEmphasis, tier: tier, cost: cost, costLabel: costLabel, quantity: quantity, cta: cta, ctaUrl: ctaUrl, description1: description1, description2: description2, linkText: linkText, linkUrl: linkUrl })=>{
    const cardHeaderCss = [
        ctaEmphasis && null,
        !ctaEmphasis && null
    ];
    const ctaCss = [
        ctaEmphasis && null,
        !ctaEmphasis && null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhkcd5j _1h6d1hxd _16qso5yx _2rko1y44 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _vwz411nn _y3gn1h6o _ca0qidpf _u5f3idpf _n3td1l27 _19bvidpf"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    ctaEmphasis && "_bfhk1hxd _1wyb1k8s _k48pbfng _1dyznl7k _vwz411ph _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f31crf _n3td1tcg _19bv1crf _1bsb1osq",
                    !ctaEmphasis && "_11q7glyw _1wyb1k8s _k48pbfng _1dyznl7k _vwz411ph _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f31crf _n3td1tcg _19bv1crf _1bsb1osq"
                ]),
                children: tier
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect41pz4 _1wyb1ady _k48pni7l _vwz4kb7n _6rth1crf _1pfh1ylp"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: cost
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syazalr3 _1wyb1k92 _vwz4cjiy"
                ]),
                children: costLabel
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syazalr3 _1wyboxwj _vwz411nn"
                ]),
                children: quantity
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: ctaUrl,
                className: (0, $2jatx.default)([
                    ctaEmphasis && "_bfhkrbzz _syaz12cp _k48pbfng _irr31cml _4cvx1cml _19it36id _2rko1l7b _1e0c1ule _1wyb7vkz _vwz4bs82 _6rth1tcg _1pfhzwfg _ca0qh72c _u5f37vkz _n3tdh72c _19bv7vkz _4bfu1snc _1hmsagmp _ajmmvv82 _v564p9y3",
                    !ctaEmphasis && "_bfhk1j28 _syaz1pd3 _k48p1nn1 _irr34m1f _4cvx1cml _19it36id _2rko1l7b _1e0c1ule _1wyb7vkz _vwz4bs82 _6rth1tcg _1pfhzwfg _ca0qh72c _u5f37vkz _n3tdh72c _19bv7vkz _4bfu1snc _1hmsagmp _ajmmvv82 _v564p9y3"
                ]),
                children: cta
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: description1
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: description2
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: linkUrl,
                children: linkText
            })
        ]
    });
};
const $1341a3436472bd20$export$8db7662682d3869a = ({ header: header, cards: cards, footer: footer })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1yd3vbgk _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1q51vbgk _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _xlt1idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1s18ahaf _14b5f2ck _syaz1bqd _ect41pz4 _k48pbfng _vwz411ph _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qzwfg _u5f37vkz _n3tdckbl _19bv7vkz _y3gn1h6o _1cqs1k8s _1u2qzwfg _1rfm1osq"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1fhb _1e0c1txw _zulpzwfg _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1gde1bp4 _q5ugidpf _7tld1wug _14adidpf _4uro1wug _1rfmf2ck _bna31osq"
                ]),
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($1341a3436472bd20$var$PricingCard, (0, $6ogO3._)({}, card), `PricingCard-${index}`))
            }),
            footer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _bfhkcd5j _1h6d1hxd _16qso5yx _2rko1y44 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _vwz411nn _y3gn1h6o _ca0qidpf _u5f3idpf _n3td1l27 _19bvidpf",
                    "_19pkzwfg _2hwx7vkz _otyrzwfg _18u07vkz _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _25gb1ylp _u9mw1ylp _13e01ylp _182g1ylp"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: footer
            })
        ]
    });
};
var $1341a3436472bd20$export$2e2bcd8739ae039 = $1341a3436472bd20$export$8db7662682d3869a;

});

parcelRegister("9RHgs", function(module, exports) {
$parcel$export(module.exports, "PricingTabs", function () { return $85217f2010396a88$export$72a589327a08c3da; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $a9CD6 = parcelRequire("a9CD6");

var $1OyVz = parcelRequire("1OyVz");

var $hK1eD = parcelRequire("hK1eD");

var $98rQm = parcelRequire("98rQm");

var $iyxHK = parcelRequire("iyxHK");
parcelRequire("7g1ev");
var $gGOh9 = parcelRequire("gGOh9");
const $85217f2010396a88$var$tabStyles = null;
const $85217f2010396a88$export$72a589327a08c3da = ({ jiraCalculatorComponent: jiraCalculatorComponent, confluenceCalculatorComponent: confluenceCalculatorComponent, trelloCalculatorComponent: trelloCalculatorComponent, loomCalculatorComponent: loomCalculatorComponent, teamworkCollectionComponent: teamworkCollectionComponent, dataProductKey: dataProductKey, banner: banner })=>{
    const intl = (0, $8e22h.default)();
    const defaultProductKey = "nonProfitCalculator";
    const defaultJiraCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Jira Component"
        });
    const defaultConfluenceCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Confluence Component"
        });
    const defaultTrelloCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Trello Component"
        });
    const defaultLoomCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const defaultTeamworkCollectionCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const JiraComponent = jiraCalculatorComponent !== null && jiraCalculatorComponent !== void 0 ? jiraCalculatorComponent : defaultJiraCalculatorComponent;
    const ConfluenceComponent = confluenceCalculatorComponent !== null && confluenceCalculatorComponent !== void 0 ? confluenceCalculatorComponent : defaultConfluenceCalculatorComponent;
    const TrelloComponent = trelloCalculatorComponent !== null && trelloCalculatorComponent !== void 0 ? trelloCalculatorComponent : defaultTrelloCalculatorComponent;
    const LoomComponent = loomCalculatorComponent !== null && loomCalculatorComponent !== void 0 ? loomCalculatorComponent : defaultLoomCalculatorComponent;
    const TeamworkCollectionComponent = teamworkCollectionComponent !== null && teamworkCollectionComponent !== void 0 ? teamworkCollectionComponent : defaultTeamworkCollectionCalculatorComponent;
    const possibleTabs = [
        {
            id: "jira",
            textLabel: intl.formatMessage({
                id: "PricingTabs.jira",
                defaultMessage: "Jira"
            }),
            component: typeof JiraComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(JiraComponent, {}) : JiraComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(jiraCalculatorComponent)
        },
        {
            id: "confluence",
            textLabel: intl.formatMessage({
                id: "PricingTabs.confluence",
                defaultMessage: "Confluence"
            }),
            component: typeof ConfluenceComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(ConfluenceComponent, {}) : ConfluenceComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9CD6.ConfluenceMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(confluenceCalculatorComponent)
        },
        {
            id: "loom",
            textLabel: intl.formatMessage({
                id: "PricingTabs.loom",
                defaultMessage: "Loom"
            }),
            component: typeof LoomComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(LoomComponent, {}) : LoomComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hK1eD.LoomMarkBrandV2), {
                className: "logoSize"
            }),
            isAvailable: Boolean(loomCalculatorComponent)
        },
        {
            id: "trello",
            textLabel: intl.formatMessage({
                id: "PricingTabs.trello",
                defaultMessage: "Trello"
            }),
            component: typeof TrelloComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(TrelloComponent, {}) : TrelloComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98rQm.TrelloMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(trelloCalculatorComponent)
        },
        {
            id: "teamwork-collection",
            elementLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_161tnagk _1lve1osq _1m8i1w81 _1pww1wug _eaz5idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyxHK.CollectionTeamworkLogoBrandV3), {})
            }),
            textLabel: intl.formatMessage({
                id: "PricingTabs.teamworkCollection",
                defaultMessage: "Teamwork Collection"
            }),
            component: typeof TeamworkCollectionComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(TeamworkCollectionComponent, {}) : TeamworkCollectionComponent,
            isAvailable: Boolean(teamworkCollectionComponent)
        }
    ];
    const tabs = possibleTabs.filter((tab)=>tab.isAvailable);
    const defaultBanner = intl.formatMessage({
        id: "tabGroup.banner",
        defaultMessage: "showing 75% off"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _1kde1ule _5pbc1f4h _mp6aglyw _1v4zidpf _1n3n1osq _si4cgrf3 _1p4fgrf3 _r7togrf3 _17a1grf3 _1ypridpf _n8lpka7h _9ss6idpf _cy2pka7h _11cq1txw _1b5s1h6o _1rvg1h6o _jmjjr3uz _inr21rga _u4d1idpf _1v9nh2mm _7l98t94y _1bvkvle5 _1gvk1x1l _150515x9 _1afqkb7n _1b7v1crf _pu7u1crf _kqje1crf _16vm1crf _rclkls4b _12lk189y _f40hcd5j _wx5ocd5j _1lxt1hdd _xaq61hdd _qr3omwu3 _1xrymwu3 _1lx01r31 _xx3h1r31 _1lleglyw _dqzjglyw _u4pp1o36 _12t91o36 _1s6ccs5v _1jp7cs5v _1lp7bsef _2g4515iw _dt8dglyw _929l14y2 _15uvglyw _1schglyw _1qmzglyw _1fv4glyw _a47gglyw _fp1f7vkz _ipo11crf _mzrv1git _1plp1osq _1ckkidpf _o6gx1wug _1bmhidpf _196a1wug _mzhvidpf _113widpf _12kyidpf _1vg7idpf _w4c110yn _9kzd10yn _1qsfglyw _fe4v7vkz _1x987vkz _1pqlidpf _1lp010j7"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_sse8eq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark900")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gGOh9.TabsCustom), {
            id: "pricingtabs",
            label: "pricing tabs",
            headerText: "",
            bodyText: "",
            className: "pricing-tabs",
            tabs: tabs,
            dataProductKey: dataProductKey !== null && dataProductKey !== void 0 ? dataProductKey : defaultProductKey,
            banner: banner !== null && banner !== void 0 ? banner : defaultBanner
        })
    });
};
$85217f2010396a88$export$72a589327a08c3da.displayName = "TabbedCalculatorSection";

});
parcelRegister("hK1eD", function(module, exports) {
$parcel$export(module.exports, "LoomMarkBrandV2", function () { return $f58adaea274070d6$export$e783a4d8175ce805; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");
const $f58adaea274070d6$export$e783a4d8175ce805 = (_param)=>{
    var { width: width = "100%", height: height = "100%", className: className } = _param, rest = (0, $aPnCa._)(_param, [
        "width",
        "height",
        "className"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", (0, $dPABA._)((0, $6ogO3._)({
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M41 22.1094H31.0579L39.6682 17.1383L37.7774 13.8622L29.167 18.8334L34.1371 10.2237L30.861 8.33173L25.891 16.9414V7H22.109V16.9423L17.137 8.33173L13.862 10.2228L18.833 18.8324L10.2227 13.8622L8.33169 17.1373L16.942 22.1085H7V25.8906H16.9411L8.33169 30.8617L10.2227 34.1378L18.8321 29.1676L13.8611 37.7772L17.137 39.6682L22.1081 31.0577V41H25.8901V31.0586L30.8601 39.6682L34.136 37.7772L29.1651 29.1667L37.7754 34.1378L39.6664 30.8617L31.057 25.8915H40.998V22.1094H41ZM24 29.1437C21.1483 29.1437 18.8368 26.8324 18.8368 23.9805C18.8368 21.1287 21.1483 18.8172 24 18.8172C26.8517 18.8172 29.1631 21.1287 29.1631 23.9805C29.1631 26.8324 26.8517 29.1437 24 29.1437Z",
            fill: "#625DF5"
        })
    }));
};
$f58adaea274070d6$export$e783a4d8175ce805.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string
};

});

parcelRegister("7g1ev", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gGOh9")).TabsCustom; });

var $gGOh9 = parcelRequire("gGOh9");

});
parcelRegister("gGOh9", function(module, exports) {
$parcel$export(module.exports, "TabsCustom", function () { return $e3221c0f304a7ad7$export$da3a983bae6b9d3a; });
/* tabs-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2tb46 = parcelRequire("2tb46");

var $kaZQn = parcelRequire("kaZQn");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $e3221c0f304a7ad7$var$CustomTabsStyle = null;
const $e3221c0f304a7ad7$export$da3a983bae6b9d3a = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, dataProductKey: dataProductKey, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", backgroundProperties: backgroundProperties, className: className, banner: banner })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.StyledBackground), (0, $dPABA._)((0, $6ogO3._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1yt41d5t _13zni5hb _15tx1jx0",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kaZQn.TabGroup), {
                        colors: colors,
                        tabContentType: "custom",
                        tabs: tabs,
                        id: id,
                        label: label,
                        dataProductKey: dataProductKey,
                        banner: banner
                    })
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $dPABA._)((0, $6ogO3._)({}, ctaProps.primaryLinkProps), {
                            text: ctaProps.primaryLinkProps.text,
                            "aria-label": ctaProps.primaryLinkProps.text
                        }))
                    })
                }) : null
            ]
        })
    }));
};

});



parcelRegister("21Gmw", function(module, exports) {
parcelRequire("gIRO7");

});

parcelRegister("gqa4z", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("baTp3")).DataCenterSection; });
parcelRequire("baTp3");

});
parcelRegister("baTp3", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return $beae9ace14d19c79$export$3e74b76dd9e071d6; });
/* data-center-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $beae9ace14d19c79$var$ctaButtonStyles = null;
const $beae9ace14d19c79$var$dataCenterSectionContainer = null;
const $beae9ace14d19c79$var$headingStyle = null;
const $beae9ace14d19c79$var$descriptionStyle = null;
const $beae9ace14d19c79$var$rightSection = null;
const $beae9ace14d19c79$var$ctaWrapper = null;
const $beae9ace14d19c79$var$svgStyles = null;
const $beae9ace14d19c79$export$64adec1d96f4a7a4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: `https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg`,
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb112f _4t3i1jj5 _1s4pawd2 _1kne10uk"
        ])
    });
};
const $beae9ace14d19c79$export$3e74b76dd9e071d6 = (props)=>{
    var _props_buttonCta, _props_buttonCta1, _props_linkCta, _props_linkCta1;
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "Pricing.DataCenterSection.title",
        defaultMessage: "Data Center Products"
    });
    const description = intl.formatMessage({
        id: "Pricing.DataCenterSection.description",
        defaultMessage: "Data Center is our self-managed product offering for customers with strict regulatory or security requirements. To learn more about this offering, please contact us."
    });
    const buttonCtaLabel = intl.formatMessage({
        id: "Pricing.DataCenterSection.buttonCta",
        defaultMessage: "Contact Us"
    });
    const linkCtaLabel = intl.formatMessage({
        id: "Pricing.DataCenterSection.linkCta",
        defaultMessage: "Learn more"
    });
    const buttonCtaHref = `https://www.atlassian.com${(0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features")}`;
    const linkCtaHref = `https://www.atlassian.com${(0, $kooLp.useLocalizedHref)("/enterprise/data-center")}`;
    var _props_title, _props_description, _props_buttonCta_href, _props_buttonCta_label, _props_linkCta_label, _props_linkCta_href;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhk17la _mkrz1ohv _1e0c1txw _4cvr1y6m _1bah1h6o _zulpvbgk _ca0q1et3 _u5f313rr _n3td88uy _19bv13rr _2osnqslr _8fz61fdn _tl281et3 _axwi1l27 _1hwcvbgk _sp8t1l27 _1s4p1osq _1gde1bp4"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($beae9ace14d19c79$export$64adec1d96f4a7a4, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syazcd5j _p12fukw8 _8fz61im0"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: "data-center-section-heading",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9"
                        ]),
                        children: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1wyb7vkz _vwz41tcg _6rth1tcg"
                        ]),
                        children: (_props_description = props.description) !== null && _props_description !== void 0 ? _props_description : description
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _zulp7vkz _1gde1bp4 _1rfmwz92"
                        ]),
                        children: [
                            props.buttonCta !== null && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                size: "small",
                                variant: "secondary",
                                color: "white",
                                colorAgainst: "other",
                                href: (_props_buttonCta_href = (_props_buttonCta = props.buttonCta) === null || _props_buttonCta === void 0 ? void 0 : _props_buttonCta.href) !== null && _props_buttonCta_href !== void 0 ? _props_buttonCta_href : buttonCtaHref,
                                className: (0, $2jatx.default)([
                                    "_4t3i1ylp _1bsbwz92 _o5721q9c"
                                ]),
                                children: (_props_buttonCta_label = (_props_buttonCta1 = props.buttonCta) === null || _props_buttonCta1 === void 0 ? void 0 : _props_buttonCta1.label) !== null && _props_buttonCta_label !== void 0 ? _props_buttonCta_label : buttonCtaLabel
                            }),
                            props.linkCta !== null && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                bgColor: "bgBlackBlue",
                                text: (_props_linkCta_label = (_props_linkCta = props.linkCta) === null || _props_linkCta === void 0 ? void 0 : _props_linkCta.label) !== null && _props_linkCta_label !== void 0 ? _props_linkCta_label : linkCtaLabel,
                                href: (_props_linkCta_href = (_props_linkCta1 = props.linkCta) === null || _props_linkCta1 === void 0 ? void 0 : _props_linkCta1.href) !== null && _props_linkCta_href !== void 0 ? _props_linkCta_href : linkCtaHref,
                                id: "data-center-section-link",
                                ariaLabelledby: "data-center-section-link data-center-section-heading"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$beae9ace14d19c79$export$3e74b76dd9e071d6.displayName = "DataCenterSection";

});


parcelRegister("8Bcrk", function(module, exports) {
/* addon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aSr2F = parcelRequire("aSr2F");

var $2fk4i = parcelRequire("2fk4i");
const $addc509816787790$var$addonContainerCss = null;
const $addc509816787790$var$sectionLeftCss = null;
const $addc509816787790$var$sectionRightCss = null;
const $addc509816787790$var$headingTextCss = null;
const $addc509816787790$var$bodyTextCss = null;
const $addc509816787790$var$featureListCss = null;
const $addc509816787790$var$featureListItemCss = null;
const $addc509816787790$export$b4fbd0ed3ac70e71 = ({ logo: logo, heading: heading, subheading: subheading, features: features, learnMore: learnMore, imgSrc: imgSrc, imgAlt: imgAlt })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _2rkogktf _bfhku67f _16qsdtw3 _zulpftgi _1bsb1osq _p12f16yw _9959vrvc _a64kzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: logo
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybqslr _k48p1nn1 _vwz41f4h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q51183y _kqswh2mm"
                        ]),
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511y44"
                        ]),
                        children: subheading
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfh183y _6rth1tcg"
                        ]),
                        children: features.map((feature, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvrv2br _zulpftgi _1q511y44"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aSr2F))), {
                                        label: "",
                                        color: "var(--ds-icon, #292A2E)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: feature
                                    })
                                ]
                            }, index))
                    }),
                    learnMore && /* eslint-disable-next-line @atlassian/a11y/anchor-has-content,@atlassian/a11y/link-name */ /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: learnMore.text,
                        type: "primary",
                        href: learnMore.href,
                        onClick: learnMore.onClick
                    })
                ]
            }),
            imgSrc && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _je3o1txw _vu061h6o _1i7q10sk"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    height: 268,
                    width: 504
                })
            })
        ]
    });
};
const $addc509816787790$export$e80698ec11357cbb = {
    eventName: "pricingAddonLearnMoreClicked",
    eventType: "ui",
    eventComponent: "linkButton",
    event: "clicked",
    actionSubject: "linkButton",
    actionSubjectId: "pricingAddonLearnMore",
    action: "clicked"
};

});

parcelRegister("jQCkx", function(module, exports) {
/* addons-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $0a61eed25b4a5849$var$rootCss = null;
const $0a61eed25b4a5849$var$angledEdgeCss = null;
const $0a61eed25b4a5849$var$headingCss = null;
const $0a61eed25b4a5849$var$childrenCss = null;
const $0a61eed25b4a5849$export$ef9150b23047bebe = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_19pkvbgk _2hwx1wug _otyrvbgk _18u01wug _bfhkdoyu _kqswh2mm _p12f194r"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syazu67f _1wybzwfg _k48p1fw0 _vwz410mc _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1wqb _u5f31tcg _n3tdidpf _19bv1tcg _1s1814no _17gqor1b _1akofhn8 _c7s71tcg _4puvidpf _1r3v1tcg _fz891ylp _1ol9ckbl _h1401wqb"
                ]),
                children: props.heading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pbykb7n _p12f194r _1bsb1osq _u7coidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($0a61eed25b4a5849$var$AngledEdgeBackground, {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbycs5v _152tckbl _1e02idpf _rjxpidpf _ahbq1wug _12l21wug _bozgzwfg _y4tizwfg _1e0c1txw _1bah1h6o _4cvr1fhb _2lx2vrvc _zulpzwfg _na0i1bp4 _dh1a1h6o _2osnckbl"
                ]),
                children: props.children
            })
        ]
    });
};
const $0a61eed25b4a5849$var$AngledEdgeBackground = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1312 180",
        fill: "none",
        width: "100%",
        height: "100%",
        className: (0, $2jatx.default)([
            "_kqswh2mm _u7co1bs0"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M0 180L1312 180L1312 0.000114699L5.65586e-06 115.305L0 180Z",
            fill: "white"
        })
    });
};

});

parcelRegister("frz5c", function(module, exports) {
$parcel$export(module.exports, "QuestionsCta", function () { return $a5fd4efc00df1131$export$7874bf850b18c607; });
/* questions-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $imIsw = parcelRequire("imIsw");
const $a5fd4efc00df1131$var$containerCss = null;
const $a5fd4efc00df1131$var$sectionLeftCss = null;
const $a5fd4efc00df1131$var$sectionLeftTextCss = null;
const $a5fd4efc00df1131$var$headingCss = null;
const $a5fd4efc00df1131$var$svgStyles = null;
const $a5fd4efc00df1131$export$7874bf850b18c607 = ({ questionsHeader: questionsHeader, questionsBody: questionsBody, priceAndLicensingLinkText: priceAndLicensingLinkText, ctaHref: ctaHref, imageHref: imageHref = "https://dam-cdn.atl.orangelogic.com/AssetLink/0s31nt386q2lt662011182pvct037sp1.svg", product: product })=>{
    const intl = (0, $8e22h.default)();
    if (!ctaHref || !product && !questionsBody) return null;
    const fallbackQuestionsHeader = intl.formatMessage({
        id: "PricingPage.QuestionsCta.questionsHeader",
        defaultMessage: "Questions?"
    });
    const fallbackQuestionsBody = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingPage.QuestionsCta.questionsBody",
        defaultMessage: "We got answers. Read our full list of common questions and answers for general cloud pricing and licensing or specific {product} pricing and licensing.",
        values: {
            product: product
        }
    });
    const text = intl.formatMessage({
        id: "PricingPage.QuestionsCta.priceAndLicensingLinkText",
        defaultMessage: "See price and licensing page"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1y6m _1bah1h6o _bfhkr3uz _1e0c1txw _syazu67f _1reoewfl _18m9ewfl _ca0qvbgk _u5f31uvc _n3tdvbgk _19bvd3xy _2osnqslr _8fz61fdn _tl28vbgk _axwi1l27 _1hwc1et3 _sp8t1l27 _1gde1sxn _1vth1hhm _mkrz22xr _zulpt9kd"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _y3gn1e5h _zulp7vkz _85i519bv _xlt110yn"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        "data-testid": "questions-cta-header",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9",
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsHeader !== null && questionsHeader !== void 0 ? questionsHeader : fallbackQuestionsHeader
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        "data-testid": "questions-cta-body",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsBody !== null && questionsBody !== void 0 ? questionsBody : fallbackQuestionsBody
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: priceAndLicensingLinkText !== null && priceAndLicensingLinkText !== void 0 ? priceAndLicensingLinkText : text,
                        href: ctaHref,
                        anchorProps: {
                            "data-testid": "questions-cta-link"
                        },
                        bgColor: "bgBlackBlue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: imageHref,
                    alt: ""
                },
                className: (0, $2jatx.default)([
                    "_1bsb7l9q _4t3irb92 _1s4pnxnw _1kne1yvi"
                ])
            })
        ]
    });
};
$a5fd4efc00df1131$export$7874bf850b18c607.displayName = "QuestionsCTASection";

});

parcelRegister("1jOvc", function(module, exports) {
$parcel$export(module.exports, "DemoAddOn", function () { return $5702e44d4b94ef8e$export$b100dca757cd91d; });
/* demo-add-on.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $imIsw = parcelRequire("imIsw");
const $5702e44d4b94ef8e$var$containerCss = null;
const $5702e44d4b94ef8e$var$sectionRightCss = null;
const $5702e44d4b94ef8e$var$headingTextCss = null;
const $5702e44d4b94ef8e$var$bodyTextCss = null;
const $5702e44d4b94ef8e$var$svgStyles = null;
const $5702e44d4b94ef8e$export$98641d5fe71eada5 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/rl8k3b0oo518e2ag657731kn07r84m04.svg",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb1qi6 _4t3ii8ts _1s4pvrzy _1kne11yp"
        ])
    });
};
const $5702e44d4b94ef8e$export$b100dca757cd91d = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const defaultHeadingText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.heading",
        defaultMessage: "See what Atlassian Guard can do for you"
    });
    const defaultBodyText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.body",
        defaultMessage: "Join our live monthly demo to gain practical guidance for implementing security best practices and controls across Atlassian cloud."
    });
    const defaultLinkText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.cta",
        defaultMessage: "Register for the demo"
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code == "Enter" || e.code == "Space") {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $2jatx.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _1bahv2br _2rkovwyg _1gde1bp4 _ag851h6o _8164183y _133ixy5q _s51s1ejb _16qst7xp _v56416gf _1dbz130s _zulpoahv",
            "_80om2v03"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_1ivi1ch": (0, $6ZVlx.default)(ctaHref ? "pointer" : "default")
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($5702e44d4b94ef8e$export$98641d5fe71eada5, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: headingText !== null && headingText !== void 0 ? headingText : defaultHeadingText
                    }),
                    bodyText !== "" && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: bodyText !== null && bodyText !== void 0 ? bodyText : defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        ariaLabelledby: "atlassian-guard-addon-cta atlassian-guard-add-on-heading"
                    })
                ]
            })
        ]
    });
};
$5702e44d4b94ef8e$export$b100dca757cd91d.displayName = "DemoAddOnSection";

});

parcelRegister("djE2J", function(module, exports) {
$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return $f4f37fc7b98c337e$export$fcf33b8d632fa1db; });
/* atlassian-guard-add-on-shared.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $imIsw = parcelRequire("imIsw");
const $f4f37fc7b98c337e$var$containerCss = null;
const $f4f37fc7b98c337e$var$sectionRightCss = null;
const $f4f37fc7b98c337e$var$atlassianGuardLogoContainerCss = null;
const $f4f37fc7b98c337e$var$headingTextCss = null;
const $f4f37fc7b98c337e$var$bodyTextCss = null;
const $f4f37fc7b98c337e$var$svgStyles = null;
const $f4f37fc7b98c337e$export$5cd54d97896804b4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xxlo4l61p3fn223u1nahuu4r6r3ug1a2.svg",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsbvrzy _4t3i11yp _glte1qi6 _165ti8ts"
        ])
    });
};
const $f4f37fc7b98c337e$export$fcf33b8d632fa1db = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const defaultHeadingText = formatMessage({
        id: "PricingPagesTeam.atlassianGuard.heading",
        defaultMessage: "Safeguard your mission-critical data"
    });
    const defaultBodyText = formatMessage({
        id: "PricingPagesTeam.atlassianGuard.body",
        defaultMessage: "Add Atlassian Guard for enhanced security and visibility across your Atlassian cloud products. Set proactive security policies, quickly detect suspicious behavior, and take action with suggested remediation steps to protect your most valuable work. Additionally, with a Cloud Enterprise plan, you get support for multiple identity providers (IdPs) and Atlassian Guard Standard."
    });
    const defaultLinkText = formatMessage({
        id: "PricingPages.atlassianGuard.cta",
        defaultMessage: "Learn more"
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "atlassianGuardAddOnShared",
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code == "Enter" || e.code == "Space") {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $2jatx.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _2rkovwyg _4cvr1h6o _1gde1bp4 _8164183y _133ixy5q _s51s1ejb _16qst7xp _v56416gf _1dbz130s _zulpoahv _80omtlke"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($f4f37fc7b98c337e$export$5cd54d97896804b4, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3ixy5q _1752xy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.GuardLogo), {
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: headingText !== null && headingText !== void 0 ? headingText : defaultHeadingText
                    }),
                    bodyText !== "" && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1io3"
                        ]),
                        style: {
                            "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                        },
                        children: bodyText !== null && bodyText !== void 0 ? bodyText : defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        ariaLabelledby: "atlassian-guard-add-on-cta atlassian-guard-add-on-heading"
                    })
                ]
            })
        ]
    });
};
$f4f37fc7b98c337e$export$fcf33b8d632fa1db.displayName = "AtlassianGuardAddOn";

});



//# sourceMappingURL=confluence-pricing-page.93ee2b6d.js.map
